import React from 'react';
import { Button } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

const ExportExcelButton = ({ data, columns, formatDate }) => {
    const handleExportExcel = () => {
        const searchElement = document.querySelector('.gridjs-search-input');
        const searchTerm = searchElement ? searchElement.value.toLowerCase() : '';
        
        // Filtra os dados se houver termo de busca
        const filteredData = searchTerm
            ? data.filter(item =>
                Object.values(item).some(val =>
                    String(val).toLowerCase().includes(searchTerm)
                )
            )
            : data;
            console.log(data);

        // Detecta automaticamente as colunas do primeiro item de dados
        const firstItem = filteredData[0] || {};
        const columnConfig = Object.keys(firstItem)
            .filter(key => key !== '__proto__') // Remove o prototype
            .map(key => ({
                key,
                name: columns.find(col => col.selector === key)?.name || key // Usa o nome da coluna definido ou a própria chave
            }));

        // Função auxiliar para formatar o valor baseado no tipo
        const formatValue = (value, key) => {
            if (value === undefined || value === null) return '';
            
            // Se o valor é uma data e temos formatDate
            if (key === 'ultimoAcesso' && formatDate) {
                return formatDate(value);
            }
            
            return value;
        };

        // Mapeia os dados usando a configuração automática das colunas
        const exportData = filteredData.map(item => {
            return columnConfig.map(col => {
                const value = item[col.key];
                return formatValue(value, col.key);
            });
        });

        const headers = columnConfig.map(col => col.name);
        const excelData = [headers, ...exportData];

        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Dados");

        // Configurações adicionais da planilha
        const wsProps = {
            '!cols': columnConfig.map(() => ({ wch: 15 })) // Largura padrão para todas as colunas
        };

        Object.assign(ws, wsProps);

        XLSX.writeFile(wb, 'dados.xlsx');
    };

    return (
        <Button 
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={handleExportExcel}
        >
            Exportar
        </Button>
    );
};

export default ExportExcelButton;